<div class="p-5 mb-4 bg-light rounded-3">
  <div class="container-fluid py-5">
    <h1 class="display-5 fw-bold">
      Usuario {{ userEmail }} <span class="text-danger">bloqueado</span>!
    </h1>
    <p class="col-md-8 fs-4">Por favor, comuníquese con el administrador.</p>
  </div>
</div>
